module.exports = __webpack_public_path__ + "img/oem2.73e9ff9c.png";